export default "__VITE_ASSET__DGkWT$0U__"